class MinimalHomepageSlider extends HTMLElement {
  connectedCallback() {
    this.handleSlideSelect = this.handleSlideSelect.bind(this);
    this.addEventListener('slideshow:select', this.handleSlideSelect);

    const slideshow = this.querySelector('slideshow-component');
    const initialIndex = Number.parseInt(slideshow?.getAttribute('initial-slide') || '0', 10);
    this.updateMetadata(Number.isNaN(initialIndex) ? 0 : initialIndex);
  }

  disconnectedCallback() {
    this.removeEventListener('slideshow:select', this.handleSlideSelect);
  }

  handleSlideSelect(event) {
    const selectedSlide = event.detail?.slide;

    if (!(selectedSlide instanceof Element) || selectedSlide.closest('minimal-homepage-slider') !== this) {
      return;
    }

    this.updateMetadata(event.detail.index);
  }

  updateMetadata(index) {
    for (const item of this.querySelectorAll('[data-minimal-slider-metadata]')) {
      const isActive = Number.parseInt(item.dataset.slideIndex || '-1', 10) === index;
      item.hidden = !isActive;
      item.setAttribute('aria-hidden', String(!isActive));
    }
  }
}

if (!customElements.get('minimal-homepage-slider')) {
  customElements.define('minimal-homepage-slider', MinimalHomepageSlider);
}